import { Button, Grid } from "@mui/material";
import { red } from "@mui/material/colors";
import { styled } from "@mui/material/styles";
import { get, includes } from "lodash";
import { useParams } from "react-router-dom-v5-compat";
import SaveAndExitButton from "../../../common/js/components/SaveAndExitButton";

const StyledPageToolBar = styled(Grid)(() => ({
    marginBottom: "20px",
    marginTop: "20px",
}));

const StyledDeleteButton = styled(Button)(() => ({
    backgroundColor: red[500],
    color: "white",
    "&:hover": {
        backgroundColor: red[800],
    },
}));

const CompanyToolbar = (props) => {
    const { userProfile, company, disableInputs, deleteCompany, history, saveCompany, saveCompanyAndExit } = props;
    const params = useParams();
    const id = params.id;
    const handleDeleteCompany = async (companyKey) => {
        const result = await deleteCompany(companyKey);
        if (result.success) {
            history.push("../admin/companies");
        }
    };

    const handleSaveCompanyAndExit = async () => {
        const result = await saveCompanyAndExit();
        if (result.success) {
            history.push("/admin/companies");
        }
    };

    return (
        <StyledPageToolBar container justifyContent="space-between" alignItems="center" spacing={16}>
            <Grid item>
                <h2 className="page-title">{get(company, "companyKey", null) == null ? "Create" : "Edit"} Company</h2>
            </Grid>
            <Grid item>
                <Grid container alignItems="center" spacing={0}>
                    <Grid item>
                        <SaveAndExitButton
                            onSave={saveCompany}
                            onSaveAndExit={handleSaveCompanyAndExit}
                            disabled={disableInputs}
                        />
                    </Grid>
                    {includes(["dataAdmin", "dataEntry"], userProfile.role) && id ? (
                        <Grid item>
                            <StyledDeleteButton
                                variant="outlined"
                                onClick={() => handleDeleteCompany(company.companyKey)}
                            >
                                Delete
                            </StyledDeleteButton>
                        </Grid>
                    ) : (
                        ""
                    )}
                </Grid>
            </Grid>
        </StyledPageToolBar>
    );
};

export default CompanyToolbar;
